<template>
  <a-modal
    v-model="imgVisible"
    :destroy-on-close="true"
    :footer="null"
    width="auto"
    :closable="false"
    centered
    class="preViewModal"
    :bodyStyle="{padding:0}"
  >
    <img :src="activeImg" class="preViewImg" @click="hide" alt="" />
  </a-modal>
</template>

<script >
export default {
  name: 'PreViewModal',
  data () {
    return {
      imgVisible: false
    }
  },
  props: {
    activeImg: {
      type: String,
      default: ''
    }
  },
  components: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {
    showModal () {
      this.imgVisible = true
    },
    hide () {
      this.imgVisible = false
    }
  }
}
</script>

<style lang='less' scoped>
// 兼容火狐
.bgModal {
  .ant-modal-content {
    background: none !important;
    box-shadow: none !important;
  }
}
.preViewModal {
  .preViewImg {
      max-width: 620px;
      cursor: pointer;
  }
}
</style>
